import * as React from "react";
import { Modal } from "antd";
import { ShowNotification } from "../../ShowNotification/ShowNotification";
import { useContext, useState } from "react";
import { ServiceContext } from "src/services/provider/Service.provider";
import IGenericButtons from "../Interfaces/IGenericButtons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "../../Tooltip/Tooltip";
import { RouteComponentProps, withRouter } from 'react-router';
import Form, { FormComponentProps } from 'antd/lib/form';
import { ChangeExpenseStatusTypeEnum } from './ChangeExpenseStatusTypeEnum';
import { IChangeExpenseStatusRequest } from 'src/services/interfaces/Expense/IChangeExpenseStatusRequest';
import { ConfirmModalExpense } from '../../confirm-modal-expense/ConfirmModalExpense';
import { IExpenseDetail } from 'src/services/interfaces/Expense/IExpenseDetail';

interface IChangeExpenseStatusButtonProps extends IGenericButtons, RouteComponentProps<any>, FormComponentProps {
  type: ChangeExpenseStatusTypeEnum;
  modalTitle?: string;
  modalReasonPlaceholder?: string;
  buttonText?: string;
  expense?: IExpenseDetail;
  warningMessage?: (expense: IExpenseDetail) => string;
  reloadList?: () => void;
  onMoveStatus?: (value: IExpenseDetail) => void;
}

const ChangeExpenseStatusButtonForm: React.FC<IChangeExpenseStatusButtonProps> = ({
  type,
  modalTitle,
  modalReasonPlaceholder,
  buttonText,
  warningMessage,
  reloadList,
  onMoveStatus,
  form,
  tooltipTitle,
  expense
}) => {
  const { expenseRequestService } = useContext(ServiceContext);
  const [isRequesting, setIsRequesting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [reason, setReason] = useState("");

  function defineLoadingVariables(isLoading: boolean) {
    setModalLoading(isLoading);
    setIsRequesting(isLoading);
  }

  function approve() {
    const approveData: IChangeExpenseStatusRequest = { expenseId: expense.id, reason };
    expenseRequestService
      .putApproveStatus(approveData)
      .then(resp => {
        if (resp.success) {
          ShowNotification.Success("Sucesso!", resp.message);
          setShowModal(false);
          onMoveStatus(null);
          reloadList();
        } else {
          ShowNotification.Error("Falha na operação", "Erro: " + resp.message);
        }
      })
      .finally(() => defineLoadingVariables(false));
  }

  function _return() {
    const approveData: IChangeExpenseStatusRequest = { expenseId: expense.id, reason };
    expenseRequestService
      .putReturnStatus(approveData)
      .then(resp => {
        if (resp.success) {
          ShowNotification.Success("Sucesso!", resp.message);
          setShowModal(false);
          onMoveStatus(null);
          reloadList();
        } else {
          ShowNotification.Error("Falha na operação", "Erro: " + resp.message);
        }
      })
      .finally(() => {
        defineLoadingVariables(false);
      });
  }

  function handleOkButton() {
    if (!isRequesting) {
      form.validateFieldsAndScroll({ scroll: { offsetTop: 150 } }, errs => {
        if (!errs) {
          defineLoadingVariables(true);
          if (type === ChangeExpenseStatusTypeEnum.approve) {
            approve();
          } else if (type === ChangeExpenseStatusTypeEnum.return) {
            _return();
          }
        }
      });
    }
  }

  function getButtonText() {
    switch (type) {
      case ChangeExpenseStatusTypeEnum.approve:
        return "Aprovar";
      case ChangeExpenseStatusTypeEnum.return:
        return "Retornar";
      default:
        return "";
    }
  }

  function getTooltipText() {
    return `${getButtonText()} solicitação de pagamento`;
  }

  function getTooltipButtonDisabledText() {
    return `Não é possível ${getButtonText()} a solicitação de pagamento`;
  }

  return (
    <>
      <Tooltip text={isRequesting ? getTooltipButtonDisabledText() : tooltipTitle ?? getTooltipText()}>
        <button
          className={`${type === ChangeExpenseStatusTypeEnum.approve ? "approve" : type === ChangeExpenseStatusTypeEnum.return ? "rollback" : ""
            } change-expense-phase btn`}
          onClick={() => setShowModal(true)}
          disabled={isRequesting}
        >
          <FontAwesomeIcon icon={type === ChangeExpenseStatusTypeEnum.approve ? faCheck : faUndoAlt} />
          <span>{buttonText ?? getButtonText()} solicitação</span>
        </button>
      </Tooltip>
      <Modal
        className="modal-mid"
        title={modalTitle ?? `Deseja ${getButtonText()} a solicitação de pagamento? Informe qualquer detalhe adicional`}
        width={"80%"}
        visible={showModal}
        onOk={handleOkButton}
        okButtonDisabled={isRequesting}
        cancelButtonDisabled={isRequesting}
        onCancel={() => setShowModal(false)}
      >
        <Form>
          <ConfirmModalExpense
            modalLoading={modalLoading}
            form={form}
            onReasonChange={setReason}
            reasonPlaceholder={modalReasonPlaceholder ?? "Comentário adicional, Informe detalhes adicionais"}
            warningMessage={warningMessage ? warningMessage(expense) : null}
          />
        </Form>
      </Modal>
    </>
  );
}

export const ChangeExpenseStatusButton = withRouter(Form.create()(ChangeExpenseStatusButtonForm));



// WEBPACK FOOTER //
// ./src/components/common/GenericButtons/ChangeStatusExpense/ChangeExpenseStatusButton.tsx